import { memo } from 'react';

export const UseHook = memo(
  (props: {
    hook: (input?: any) => any;
    arg?: any;
    onReturn?: (result: any) => void;
  }) => {
    const result = props.hook(props.arg);
    props.onReturn?.(result);
    return null;
  },
);
